import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../components/Icon";
import { Button } from "../components/ui";
import PhotoButton from "../components/PhotoButton";
import { apiSend } from "../api";
import { useI18n } from "../i18n";
import { C, R, S } from "../theme";

const CATS = [{ key: "bug", tkey: "feedback.catBug" }, { key: "feature", tkey: "feedback.catFeature" }, { key: "help", tkey: "feedback.catHelp" }];

export default function Feedback() {
  const { t: tr } = useI18n();
  const nav = useNavigate();
  const [cat, setCat] = useState("bug");
  const [message, setMessage] = useState("");
  const [shot, setShot] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const submit = async () => {
    setMsg("");
    if (!message.trim()) { setMsg(tr("feedback.writeMessage")); return; }
    setBusy(true);
    try { await apiSend("/feedback", "POST", { category: cat, message, screenshot: shot }); setMsg("✅ " + tr("feedback.sent")); setMessage(""); setShot(null); }
    catch (e) { setMsg("❌ " + (e?.message || tr("feedback.failed"))); } finally { setBusy(false); }
  };

  return (
    <div className="fade-up">
      <div style={{ display: "flex", alignItems: "center", gap: S.sm, padding: S.lg }}>
        <button className="pressable" onClick={() => nav(-1)}><Icon name="chevron-back" size={28} color={C.text} /></button>
        <div className="display" style={{ color: C.text, fontSize: 20, fontWeight: 900 }}>{tr("feedback.title")}</div>
      </div>
      <div style={{ padding: S.lg }}>
        <div data-testid="support-email" style={{ display: "flex", alignItems: "center", gap: S.sm, background: C.card, border: `1px solid ${C.border}`, borderRadius: R.md, padding: S.md, marginBottom: S.md }}>
          <Icon name="mail" size={18} color={C.amber} />
          <span style={{ color: C.sub, fontSize: 13 }}>{tr("feedback.needHelp")} <a href="mailto:will_em@hotmail.co.uk" style={{ color: C.amber, fontWeight: 700 }}>will_em@hotmail.co.uk</a></span>
        </div>
        <div style={{ display: "flex", gap: S.sm, marginBottom: S.md }}>
          {CATS.map((c) => <button key={c.key} data-testid={`fb-${c.key}`} onClick={() => setCat(c.key)} style={{ flex: 1, background: cat === c.key ? C.amber : C.card2, borderRadius: R.md, padding: `${S.md}px 0`, color: cat === c.key ? C.black : C.text, fontWeight: 800, border: `1px solid ${C.borderStrong}` }}>{tr(c.tkey)}</button>)}
        </div>
        <textarea data-testid="fb-message" value={message} onChange={(e) => setMessage(e.target.value)} placeholder={tr("feedback.messagePh")} style={{ background: C.card2, borderRadius: R.md, border: `1px solid ${C.borderStrong}`, color: C.text, fontSize: 16, padding: S.md, minHeight: 120, width: "100%", outline: "none", marginBottom: S.md }} />
        <div style={{ color: C.sub, fontSize: 13, fontWeight: 700, marginBottom: S.sm, textTransform: "uppercase" }}>{tr("feedback.screenshot")}</div>
        <PhotoButton value={shot} onCapture={setShot} allowGallery testID="fb-shot" />
        <div style={{ height: S.md }} />
        {!!msg && <div style={{ color: msg.startsWith("✅") ? C.green : C.red, fontWeight: 700, marginBottom: S.sm }}>{msg}</div>}
        <Button title={tr("feedback.send")} testID="fb-send" onPress={submit} loading={busy} />
      </div>
    </div>
  );
}
